import React, { lazy, Suspense, useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useHistory } from 'react-router-dom';
import { useLockBodyScroll } from '~/hooks';
import Button from './Button';

const Slider = lazy(() => import('react-slick'));

const slickRoot = document.getElementById('slick-root');

export default ({ close, images, initialSlide }) => {
  const mainRef = useRef();

  useEffect(() => {
    if (mainRef) {
      mainRef.current?.innerSlider.list.setAttribute('tabindex', 0);
      mainRef.current?.innerSlider.list.focus();
    }
  }, []);

  useLockBodyScroll();
  const [el] = useState(document.createElement('div'));

  const history = useHistory();

  const back = (e) => {
    e && e.stopPropagation();
    history.goBack();
  };

  const goBack = close || back;

  const onEsc = (event) => {
    if (event.keyCode === 27) goBack();
  };

  useEffect(() => {
    document.addEventListener('keydown', onEsc, false);
    slickRoot.appendChild(el);

    return () => {
      document.removeEventListener('keydown', onEsc, false);
      slickRoot.removeChild(el);
    };
  }, []);

  const modal = (
    <div className="nui-modal-overlay">
      <div className="tc" />
      <Button className="modal-close close-gallery" onClick={close}>
        <span className="icon-cancel-1"></span>
      </Button>

      <div className="gallery-wrapper">
        <Suspense>
          <Slider
            ref={mainRef}
            buttons={images.length > 1}
            easing="easeInOutCubic"
            initialSlide={initialSlide}
          >
            {images.map((item) => (
              <div key={item.id}>
                <img src={item.src} alt={item.name} />
              </div>
            ))}
          </Slider>
        </Suspense>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, el);
};
